function pluralize(count, string, ...args) {
  return count + " " + string + (count > 1 ? "s" : "") + args.reduce((acc, str) => acc + " " + str, " ");
}

export default pluralize;
